
import React from 'react';
import { i18n } from 'config/locales';
import {
  CommonOnUpdate, CommonOnError, CommonScrollIntoView, CommonRequired
} from 'types/props';
import ValidationElement, {
  ValidationElementProps,
} from 'components/Form/ValidationElement/ValidationElement';
import classnames from 'classnames';
import { AccordionItemProps } from 'components/Form/Accordion/types';
import BranchCollection from 'components/Form/BranchCollection';
import PVQName from 'components/Form/PVQName';
import Branch from 'components/Form/Branch';
import { LegalNonCriminalCourtActionsItemModel } from 'forms/sections/legal/court/types';
import { AdditionalOppositionsItemModel } from 'forms/sections/legal/court/types';
import RadioGroup from 'components/Form/RadioGroup';
import Radio from 'components/Form/Radio';
import Field from 'components/Form/Field';
import { courtPartyStatus } from 'constants/enums/legalOptions';


type AdditionalOppositionsType = LegalNonCriminalCourtActionsItemModel['AdditionalOppositions']
interface Props extends ValidationElementProps {
  onUpdate?: CommonOnUpdate
  onError?: CommonOnError
  className?: string
  scrollIntoView?: CommonScrollIntoView
  required?: CommonRequired
  attribute?: string
}
export default class AdditionalOppositions extends ValidationElement<Props> {
  updateBranch = (values: Partial<AdditionalOppositionsType>) => {
    this.props.onUpdate({
      ...values,
    });
  };

  render() {
    return (
      <div className={classnames('court-actions', this.props.className)}>

        <BranchCollection
          label={i18n.t('legal.pvq.nonCriminalAction.heading.additionalOppositions')}
          labelSize="h4"
          appendLabel={i18n.t('legal.pvq.nonCriminalAction.heading.additionalOppositions')}
          appendSize="h4"
          {...(this.props || {})}
          onUpdate={this.updateBranch}
          onError={this.props.onError}
          scrollIntoView={this.props.scrollIntoView}
        >

          <OppositionItem
            {...this.props}
            bind name="Item" />

        </BranchCollection>
      </div>

    )
  }
}


interface ItemProps
  extends Props,
  Partial<AdditionalOppositionsItemModel>,
  Omit<AccordionItemProps, 'name'> { }

const OppositionItem: React.FC<ItemProps> = ({
  scrollIntoView,
  required,
  attribute: propAttribute,
  $index,
  OppositionPartyName,
  OppositionCourtPartyStatus,
  onUpdate: propOnUpdate,
  onError,
}) => {
  const attribute = `${propAttribute}.items[${$index}].Item`;
  const dataModel: Partial<AdditionalOppositionsItemModel> = {
    OppositionPartyName,
    OppositionCourtPartyStatus,

  };
  const onUpdate = (key: keyof AdditionalOppositionsItemModel) => (values: unknown) => {
    propOnUpdate({
      ...dataModel,
      [key]: values,
    });
  };


  return (
    <>
      <PVQName
        {...OppositionPartyName}
        attribute={`${attribute}.OppositionPartyName`}
        name="AdditionalOppositionName"
        title={i18n.t('legal.pvq.nonCriminalAction.heading.oppositionPartyName')}
        aria-label="Provide your full name"
        onUpdate={onUpdate('OppositionPartyName')}
        onError={onError}
        required={required}
        scrollIntoView={scrollIntoView}
        textPrefix="applicantName"
        prefix="name"
        hideNoFirstName
      />
      <br></br>
      <br></br>
      <Field
        attribute={`${attribute}.OppositionCourtPartyStatus`}
        title={i18n.t('legal.pvq.nonCriminalAction.heading.oppositionCourtPartyStatus')}
        scrollIntoView={scrollIntoView}
        className="status"
      >
        <RadioGroup
          attribute={`${attribute}.OppositionCourtPartyStatus`}
          className="oppositionCourtPartyStatus option-list"
          selectedValue={(OppositionCourtPartyStatus || {}).value}
          onError={onError}
          required={true}
        >
          <Radio
            name="oppositionCourtPartyStatus"
            className="oppositionCourtPartyStatus yes"
            label={courtPartyStatus.plaintiff}
            value="Plaintiff"
            onUpdate={onUpdate('OppositionCourtPartyStatus')}
            onError={onError}
          />
          <Radio
            name="oppositionCourtPartyStatus"
            className="oppositionCourtPartyStatus no"
            label={courtPartyStatus.defendant}
            value="Defendant"
            onUpdate={onUpdate('OppositionCourtPartyStatus')}
            onError={onError}
          />
        </RadioGroup>
      </Field>
    </>
  );

};

AdditionalOppositions.defaultProps = {
  onUpdate: (queue) => { },
  onError: (value, arr) => arr,
  OppositionPartyName: {},
  OppositionCourtPartyStatus: {},
};
